/*
    TODO: Feeds styles go here
*/

// For now, import everything and let webpack's deduplication solve this
import "web/css/index.less";
